/* KrutiKala account pages — password visibility, strength meter, recovery toggle */
'use strict';

(function () {
  // ── Password visibility toggle ────────────────────────────────────────────
  document.querySelectorAll('[data-kk-password-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.getAttribute('data-kk-password-toggle'));
      if (!input) return;
      var hidden = input.type === 'password';
      input.type = hidden ? 'text' : 'password';
      btn.classList.toggle('is-visible', hidden);
      btn.setAttribute('aria-label', hidden ? 'Hide password' : 'Show password');
    });
  });

  // ── Password strength meter ───────────────────────────────────────────────
  var LEVELS = ['weak', 'fair', 'good', 'strong'];
  var LABELS = { weak: 'Weak', fair: 'Fair', good: 'Good', strong: 'Strong' };

  function score(pw) {
    var n = 0;
    if (pw.length >= 8) n++;
    if (pw.length >= 12) n++;
    if (/[0-9]/.test(pw)) n++;
    if (/[a-zA-Z]/.test(pw)) n++;
    if (/[^a-zA-Z0-9]/.test(pw)) n++;
    if (n <= 1) return 'weak';
    if (n === 2) return 'fair';
    if (n === 3) return 'good';
    return 'strong';
  }

  document.querySelectorAll('[data-kk-strength-for]').forEach(function (meter) {
    var input = document.getElementById(meter.getAttribute('data-kk-strength-for'));
    if (!input) return;

    var bars = meter.querySelectorAll('.kk-auth__strength-bar');
    var label = meter.querySelector('.kk-auth__strength-label');
    var reqs = document.querySelectorAll('[data-kk-reqs-for="' + input.id + '"] .kk-auth__req');
    var reqsList = document.querySelector('[data-kk-reqs-for="' + input.id + '"]');

    input.addEventListener('input', function () {
      var pw = input.value;

      if (!pw) {
        meter.hidden = true;
        if (reqsList) reqsList.hidden = true;
        return;
      }

      meter.hidden = false;
      if (reqsList) reqsList.hidden = false;

      var level = score(pw);
      var filled = LEVELS.indexOf(level) + 1;

      meter.setAttribute('data-level', level);
      meter.setAttribute('aria-valuenow', String(filled));
      meter.setAttribute('aria-valuetext', LABELS[level]);
      if (label) label.textContent = LABELS[level];

      bars.forEach(function (bar, i) {
        bar.classList.toggle('is-on', i < filled);
      });

      reqs.forEach(function (req) {
        var rule = req.getAttribute('data-kk-req');
        var met = false;
        if (rule === 'length') met = pw.length >= 8;
        else if (rule === 'letter') met = /[a-zA-Z]/.test(pw);
        else if (rule === 'number') met = /[0-9]/.test(pw);
        req.classList.toggle('is-met', met);
      });
    });
  });

  // ── Password recovery view toggle (login page) ────────────────────────────
  var loginView = document.querySelector('[data-kk-auth-view="login"]');
  var recoverView = document.querySelector('[data-kk-auth-view="recover"]');

  function showRecover(show) {
    if (!loginView || !recoverView) return;
    loginView.hidden = show;
    recoverView.hidden = !show;
    if (show) {
      var field = recoverView.querySelector('input[type="email"]');
      if (field) field.focus();
    }
  }

  var forgotCorner = document.querySelector('.kk-auth__forgot-corner');
  var _showRecover = showRecover;
  showRecover = function (show) {
    _showRecover(show);
    if (forgotCorner) forgotCorner.hidden = show;
  };

  document.querySelectorAll('[data-kk-show-recover]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      showRecover(true);
      if (history.replaceState) history.replaceState(null, '', '#recover');
    });
  });

  document.querySelectorAll('[data-kk-show-login]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      showRecover(false);
      if (history.replaceState) history.replaceState(null, '', window.location.pathname);
    });
  });

  // Shopify redirects back with #recover after a reset request
  if (window.location.hash === '#recover') showRecover(true);

  document.querySelectorAll('[data-kk-social]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var note = document.querySelector('[data-kk-social-note]');
      if (note) note.hidden = false;
      var email = document.querySelector('.kk-auth__input[type="email"]');
      if (email) email.focus();
    });
  });

  var emailField = document.querySelector('[data-kk-login-email]');
  var passField = document.querySelector('[data-kk-login-password]');
  var submitBtn = document.querySelector('[data-kk-login-submit]');
  var loginForm = document.querySelector('[data-kk-login-form]');
  var loginClientError = document.querySelector('[data-kk-login-client-error]');
  var emailError = document.querySelector('[data-kk-login-email-error]');
  var passwordError = document.querySelector('[data-kk-login-password-error]');

  function safeReturnTo(value, fallback) {
    if (!value) return fallback;
    try {
      value = decodeURIComponent(value);
    } catch (e) {}
    if (value.charAt(0) !== '/' || value.indexOf('//') === 0) return fallback;
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(value)) return fallback;
    return value;
  }

  function applyLoginReturnTo() {
    var fallback = (window.KKSession && window.KKSession.homeUrl) || '/';
    var requested = '';
    try {
      requested = new URLSearchParams(window.location.search).get('return_to') || '';
    } catch (e) {}
    var next = safeReturnTo(requested, fallback);
    if (next.indexOf('/pages/login') === 0) next = fallback;
    var returnInput = document.querySelector('[data-kk-login-return]');
    var checkoutInput = document.querySelector('[data-kk-login-checkout]');
    if (returnInput) returnInput.value = next;
    if (checkoutInput) checkoutInput.value = next;
    document.querySelectorAll('a.kk-auth__social-btn[href*="customer_authentication"]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('return_to', next);
        link.href = url.toString();
      } catch (e) {}
    });
    if (window.KKAuth) window.KKAuth.homeUrl = next;
  }

  function setFieldError(field, errorEl, message) {
    if (errorEl) {
      errorEl.hidden = !message;
      errorEl.textContent = message || '';
    }
    if (field) field.classList.toggle('is-invalid', !!message);
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function showLoginClientError(message) {
    if (!loginClientError) return;
    loginClientError.hidden = !message;
    loginClientError.textContent = message || '';
  }

  function hostedAuth() {
    return !!(window.KKAuth && window.KKAuth.hosted && window.KKAuth.signInUrl);
  }

  function syncLoginBtn() {
    if (!submitBtn || !emailField) return;
    var ready = emailField.value.trim() !== '';
    if (!hostedAuth() && passField) ready = ready && passField.value.trim() !== '';
    submitBtn.classList.toggle('is-ready', ready);
  }
  if (emailField) {
    emailField.addEventListener('input', function () {
      setFieldError(emailField, emailError, '');
      showLoginClientError('');
      syncLoginBtn();
    });
  }
  if (passField) {
    passField.addEventListener('input', function () {
      setFieldError(passField, passwordError, '');
      showLoginClientError('');
      syncLoginBtn();
    });
  }
  syncLoginBtn();

  (function showRegisteredLogin() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    var hint = params.get('login_hint') || '';
    var registered = params.get('registered') === '1';
    var hostedAccount = /\/\d+\/account/.test(window.location.pathname);
    if (!registered && !hostedAccount) return;
    if (emailField && hint) emailField.value = hint;
    var note = document.querySelector('[data-kk-registered-note]');
    if (note) note.hidden = false;
    document.title = 'Sign in – ' + (document.title.split('–').pop() || document.title).trim();
    syncLoginBtn();
  })();

  applyLoginReturnTo();

  if (loginForm) {
    loginForm.addEventListener('submit', function (event) {
      var email = emailField ? emailField.value.trim() : '';
      var password = passField ? passField.value : '';
      var hosted = hostedAuth();
      var ok = true;

      if (!email) {
        setFieldError(emailField, emailError, 'Enter your email address.');
        ok = false;
      } else if (!validEmail(email)) {
        setFieldError(emailField, emailError, 'Enter a valid email address.');
        ok = false;
      } else {
        setFieldError(emailField, emailError, '');
      }

      if (!hosted) {
        if (!password) {
          setFieldError(passField, passwordError, 'Enter your password.');
          ok = false;
        } else if (password.length < 5) {
          setFieldError(passField, passwordError, 'Password is too short.');
          ok = false;
        } else {
          setFieldError(passField, passwordError, '');
        }
      }

      if (!ok) {
        event.preventDefault();
        showLoginClientError('Please fix the highlighted fields to sign in.');
        if (emailField && emailField.classList.contains('is-invalid')) emailField.focus();
        else if (passField) passField.focus();
      }
    });
  }

  var registerForm = document.querySelector('[data-kk-register-form]');
  var registerSubmit = document.querySelector('[data-kk-register-submit]');
  var registerClientError = document.querySelector('[data-kk-register-client-error]');
  var registerNote = document.querySelector('[data-kk-register-note]');

  function registerField(name) {
    return document.querySelector('[data-kk-register-field="' + name + '"]');
  }

  function registerError(name) {
    return document.querySelector('[data-kk-register-error="' + name + '"]');
  }

  function setRegisterError(name, message) {
    var field = registerField(name);
    if (name === 'state') {
      var country = registerField('country');
      var india = !country || country.value === 'India';
      field = india ? registerField('state') : registerField('state_text');
      var other = india ? registerField('state_text') : registerField('state');
      if (other) other.classList.remove('is-invalid');
    }
    var errorEl = registerError(name);
    if (errorEl) {
      errorEl.hidden = !message;
      errorEl.textContent = message || '';
    }
    if (field && field.type !== 'checkbox' && field.type !== 'radio') {
      field.classList.toggle('is-invalid', !!message);
    }
    if (name === 'terms' && field) field.classList.toggle('is-invalid', !!message);
    if (name === 'email' && message) {
      if (field) field.classList.remove('is-valid');
      var okEl = document.querySelector('[data-kk-register-ok="email"]');
      if (okEl) okEl.hidden = true;
    }
  }

  function registerStateValue() {
    var country = registerField('country');
    var stateSelect = registerField('state');
    var stateText = registerField('state_text');
    var india = !country || country.value === 'India';
    if (india) return stateSelect ? stateSelect.value.trim() : '';
    return stateText ? stateText.value.trim() : '';
  }

  function syncRegisterPlace() {
    var country = registerField('country');
    var stateSelect = registerField('state');
    var stateText = registerField('state_text');
    if (!country || !stateSelect || !stateText) return;
    var india = country.value === 'India';
    stateSelect.hidden = !india;
    stateSelect.required = india;
    stateText.hidden = india;
    stateText.required = !india;
    if (!india && stateSelect.value) stateText.value = stateText.value || '';
  }

  function registerValues() {
    var gender = document.querySelector('[data-kk-register-field="gender"]:checked');
    return {
      firstName: registerField('first_name') ? registerField('first_name').value.trim() : '',
      lastName: registerField('last_name') ? registerField('last_name').value.trim() : '',
      email: registerField('email') ? registerField('email').value.trim() : '',
      phone: registerField('phone') ? registerField('phone').value.trim() : '',
      city: registerField('city') ? registerField('city').value.trim() : '',
      state: registerStateValue(),
      country: registerField('country') ? registerField('country').value.trim() : '',
      dob: registerField('dob') ? registerField('dob').value : '',
      gender: gender ? gender.value : '',
      password: registerField('password') ? registerField('password').value : '',
      passwordConfirm: registerField('password_confirm') ? registerField('password_confirm').value : '',
      terms: registerField('terms') ? registerField('terms').checked : false,
    };
  }

  function persistPendingProfile(values) {
    try {
      var email = String(values.email || '').toLowerCase();
      if (!email) return;
      var profile = {
        email: email,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: normalizePhone(values.phone, values.country || 'India'),
      };
      localStorage.setItem('kk-profile-pending', JSON.stringify(profile));
      var all = {};
      try {
        all = JSON.parse(localStorage.getItem('kk-profiles') || '{}') || {};
      } catch (err) {}
      all[email] = profile;
      localStorage.setItem('kk-profiles', JSON.stringify(all));
    } catch (e) {}
  }

  function buildRegisterNote(values) {
    var lines = [];
    if (values.firstName) lines.push('First name: ' + values.firstName);
    if (values.lastName) lines.push('Last name: ' + values.lastName);
    var phone = normalizePhone(values.phone, values.country || 'India');
    if (phone) lines.push('Phone: ' + phone);
    return lines.join('\n');
  }

  var DUMMY_EMAIL_LOCALS = {
    temp: 1,
    test: 1,
    demo: 1,
    fake: 1,
    abc: 1,
    xyz: 1,
    asdf: 1,
    qwerty: 1,
    user: 1,
    admin: 1,
    email: 1,
    sample: 1,
    example: 1,
    null: 1,
    none: 1,
  };

  var DISPOSABLE_EMAIL_DOMAINS = {
    'tempgmailer.com': 1,
    'dispose.lol': 1,
    'mailticking.com': 1,
    'tempail.com': 1,
    'necub.com': 1,
    'gmailnator.com': 1,
    'emailnator.com': 1,
    'smailpro.com': 1,
    'tempmail.lol': 1,
    'mailinator.com': 1,
    'yopmail.com': 1,
    'guerrillamail.com': 1,
    'guerrillamail.net': 1,
    'guerrillamail.org': 1,
    'sharklasers.com': 1,
    'grr.la': 1,
    '10minutemail.com': 1,
    '10minutemail.net': 1,
    'tempmail.com': 1,
    'temp-mail.org': 1,
    'temp-mail.io': 1,
    'tempmail.net': 1,
    'tempmailo.com': 1,
    'tempr.email': 1,
    'throwawaymail.com': 1,
    'trashmail.com': 1,
    'getnada.com': 1,
    'nada.email': 1,
    'dispostable.com': 1,
    'maildrop.cc': 1,
    'mailnesia.com': 1,
    'mintemail.com': 1,
    'mohmal.com': 1,
    'emailondeck.com': 1,
    'fakeinbox.com': 1,
    'fakemail.net': 1,
    'mailcatch.com': 1,
    'spamgourmet.com': 1,
    'mytemp.email': 1,
    'tempinbox.com': 1,
    'burnermail.io': 1,
    'moakt.com': 1,
    'emailfake.com': 1,
    'mail.tm': 1,
    'mail.gw': 1,
    'inboxkitten.com': 1,
    'tmpmail.org': 1,
    'tmpmail.net': 1,
    'example.com': 1,
    'example.org': 1,
    'example.net': 1,
    'test.com': 1,
  };

  var DISPOSABLE_EMAIL_KEYWORDS = /temp-?g?mail|tempail|dispos|mailtick|gmailnator|emailnator|tmp-?mail|tempinbox|tempemail|temporary-?mail|throwaway|trash-?mail|fake-?mail|fakeinbox|disposable|burner-?mail|10-?minute|minute-?mail|guerrilla|mailinator|yopmail|spambox|spamgourmet|getnada|dropmail|mailtemp|emailtemp/;
  var disposableSet = null;

  function disposableList() {
    if (disposableSet) return disposableSet;
    if (typeof window.KKDisposableDomains !== 'string') return null;
    disposableSet = {};
    window.KKDisposableDomains.split(' ').forEach(function (d) {
      if (d) disposableSet[d] = 1;
    });
    return disposableSet;
  }

  function isDisposableDomain(domain) {
    var list = disposableList();
    var labels = domain.split('.');
    for (var i = 0; i < labels.length - 1; i++) {
      var candidate = labels.slice(i).join('.');
      if (DISPOSABLE_EMAIL_DOMAINS[candidate] || (list && list[candidate])) return true;
    }
    return DISPOSABLE_EMAIL_KEYWORDS.test(labels.slice(0, -1).join('.'));
  }

  // Misspellings of the mail providers Indian shoppers use most. A code sent to
  // one of these silently disappears, so catch them before the account is made.
  var EMAIL_DOMAIN_FIXES = {
    'gmai.com': 'gmail.com',
    'gmial.com': 'gmail.com',
    'gmaill.com': 'gmail.com',
    'gmail.om': 'gmail.com',
    'gmil.com': 'gmail.com',
    'gmal.com': 'gmail.com',
    'gamil.com': 'gmail.com',
    'gnail.com': 'gmail.com',
    'ggmail.com': 'gmail.com',
    'gmail.co': 'gmail.com',
    'yaho.com': 'yahoo.com',
    'yahooo.com': 'yahoo.com',
    'yhoo.com': 'yahoo.com',
    'yahoo.co': 'yahoo.com',
    'hotmai.com': 'hotmail.com',
    'hotmal.com': 'hotmail.com',
    'hotmial.com': 'hotmail.com',
    'hotnail.com': 'hotmail.com',
    'outlok.com': 'outlook.com',
    'outllok.com': 'outlook.com',
    'outlook.co': 'outlook.com',
    'redifmail.com': 'rediffmail.com',
    'rediffmai.com': 'rediffmail.com',
    'rediffmail.co': 'rediffmail.com',
    'iclod.com': 'icloud.com',
    'icluod.com': 'icloud.com',
    'icloud.co': 'icloud.com',
  };

  // Only clearly invalid endings. Real TLDs such as .co, .cm and .om are left alone.
  var EMAIL_TLD_FIXES = {
    con: 'com',
    cpm: 'com',
    cmo: 'com',
    ocm: 'com',
    xom: 'com',
    vom: 'com',
    cim: 'com',
    ckm: 'com',
    comm: 'com',
    coom: 'com',
    ner: 'net',
    nte: 'net',
    nett: 'net',
    ogr: 'org',
    orgg: 'org',
  };

  function emailTypoFix(value) {
    var pieces = String(value || '').trim().toLowerCase().split('@');
    if (pieces.length !== 2 || !pieces[0] || !pieces[1]) return '';
    var local = pieces[0];
    var domain = pieces[1];
    if (EMAIL_DOMAIN_FIXES[domain]) return local + '@' + EMAIL_DOMAIN_FIXES[domain];
    var labels = domain.split('.');
    var tld = labels[labels.length - 1];
    if (EMAIL_TLD_FIXES[tld]) {
      labels[labels.length - 1] = EMAIL_TLD_FIXES[tld];
      return local + '@' + labels.join('.');
    }
    return '';
  }

  var PHONE_RULES = {
    India: {
      code: '91',
      length: 10,
      placeholder: '98765 43210',
      test: function (n) { return /^[6-9]\d{9}$/.test(n); },
      message: 'Enter a 10-digit Indian mobile number starting with 6, 7, 8, or 9.',
    },
    'United Arab Emirates': {
      code: '971',
      length: 9,
      placeholder: '50 123 4567',
      test: function (n) { return /^5\d{8}$/.test(n); },
      message: 'Enter a 9-digit UAE mobile number starting with 5.',
    },
    'United States': {
      code: '1',
      length: 10,
      placeholder: '201 555 0143',
      test: function (n) { return /^[2-9]\d{2}[2-9]\d{6}$/.test(n); },
      message: 'Enter a 10-digit US mobile number.',
    },
    'United Kingdom': {
      code: '44',
      length: 10,
      placeholder: '7123 456789',
      test: function (n) { return /^7\d{9}$/.test(n); },
      message: 'Enter a 10-digit UK mobile number starting with 7.',
    },
    Canada: {
      code: '1',
      length: 10,
      placeholder: '204 555 0143',
      test: function (n) { return /^[2-9]\d{2}[2-9]\d{6}$/.test(n); },
      message: 'Enter a 10-digit Canadian mobile number.',
    },
    Australia: {
      code: '61',
      length: 9,
      placeholder: '412 345 678',
      test: function (n) { return /^4\d{8}$/.test(n); },
      message: 'Enter a 9-digit Australian mobile number starting with 4.',
    },
    Singapore: {
      code: '65',
      length: 8,
      placeholder: '8123 4567',
      test: function (n) { return /^[89]\d{7}$/.test(n); },
      message: 'Enter an 8-digit Singapore mobile number starting with 8 or 9.',
    },
    Nepal: {
      code: '977',
      length: 10,
      placeholder: '9801234567',
      test: function (n) { return /^9[6-8]\d{8}$/.test(n); },
      message: 'Enter a 10-digit Nepal mobile number starting with 96, 97, or 98.',
    },
    'Sri Lanka': {
      code: '94',
      length: 9,
      placeholder: '712345678',
      test: function (n) { return /^7\d{8}$/.test(n); },
      message: 'Enter a 9-digit Sri Lankan mobile number starting with 7.',
    },
    Bangladesh: {
      code: '880',
      length: 10,
      placeholder: '1712345678',
      test: function (n) { return /^1[3-9]\d{8}$/.test(n); },
      message: 'Enter a 10-digit Bangladesh mobile number starting with 13–19.',
    },
  };

  function phoneRule(country) {
    return PHONE_RULES[country] || PHONE_RULES.India;
  }

  function personNameError(value, label) {
    if (!value) return 'Enter your ' + label + '.';
    if (!/^[A-Za-z][A-Za-z .'-]*$/.test(value) || !/[A-Za-z].*[A-Za-z]/.test(value)) {
      return 'Enter a valid ' + label + ' using letters.';
    }
    return '';
  }

  var KEYBOARD_RUNS = ['qwertyuiop', 'asdfghjkl', 'zxcvbnm', 'abcdefghijklmnopqrstuvwxyz'];
  var FAKE_LOCAL_PATTERN = /^test|test\d|fake|dummy|spam|junk|asdf|qwert|zxcv|noemail|nomail|example|nothing|random/;

  function hasKeyboardRun(letters) {
    for (var r = 0; r < KEYBOARD_RUNS.length; r++) {
      var row = KEYBOARD_RUNS[r];
      var rev = row.split('').reverse().join('');
      for (var i = 0; i + 5 <= row.length; i++) {
        if (letters.indexOf(row.substr(i, 5)) !== -1 || letters.indexOf(rev.substr(i, 5)) !== -1) return true;
      }
    }
    return false;
  }

  function looksFakeLocal(local) {
    var letters = local.replace(/[^a-z]/g, '');
    if (/(.)\1{3,}/.test(local)) return true;
    if (FAKE_LOCAL_PATTERN.test(letters)) return true;
    if (hasKeyboardRun(letters)) return true;
    if (letters.length >= 6 && !/[aeiouy]/.test(letters)) return true;
    if (/[bcdfghjklmnpqrstvwxz]{6,}/.test(letters)) return true;
    return false;
  }

  function gmailError(local, domain) {
    if (domain === 'googlemail.com') return 'Please enter your address with @gmail.com instead of @googlemail.com.';
    if (!/^[a-z0-9.]+$/.test(local)) return 'Gmail addresses can only contain letters, numbers and dots.';
    var core = local.replace(/\./g, '');
    if (core.length < 6 || core.length > 30) return 'Gmail usernames are 6 to 30 characters long. Please check your Gmail address.';
    var parts = local.split('.');
    var shortParts = parts.filter(function (p) { return p.length < 3; }).length;
    if (parts.length > 3 || (parts.length === 3 && shortParts >= 2)) {
      return 'Temporary Gmail addresses are not allowed. Please enter your own Gmail without extra dots.';
    }
    return '';
  }

  function registerEmailError(value) {
    var email = String(value || '').trim().toLowerCase();
    if (!email) return 'Enter your email address.';
    if (/\s/.test(email)) return 'Email address cannot contain spaces.';
    if (email.indexOf('@') === -1) return 'Email address must include @ (for example, name@gmail.com).';
    if (email.length > 254) return 'Email address is too long.';
    var pieces = email.split('@');
    if (pieces.length !== 2 || !pieces[0] || !pieces[1]) return 'Enter a valid email address.';
    var local = pieces[0];
    var domain = pieces[1];
    if (!/^[a-z0-9-]+(\.[a-z0-9-]+)+$/.test(domain)) return 'Enter a valid email address.';
    var labels = domain.split('.');
    var tld = labels[labels.length - 1];
    var host = labels.slice(0, -1).join('');
    if (!/^[a-z]{2,24}$/.test(tld) || !/[a-z]/.test(host) || /^-|-$/.test(domain)) {
      return 'Enter a valid email address.';
    }
    if (isDisposableDomain(domain)) {
      return 'Temporary or disposable email addresses are not allowed. Please use your personal email.';
    }
    if (!/^[a-z][a-z0-9._-]{1,63}$/.test(local) || local.indexOf('..') !== -1 || /[._-]$/.test(local) || /[._-]{2,}/.test(local)) {
      return 'Enter a valid email address.';
    }
    var letters = local.replace(/[0-9._-]/g, '');
    if (letters.length < 3 || DUMMY_EMAIL_LOCALS[letters] || DUMMY_EMAIL_LOCALS[local]) {
      return 'Enter a real email address.';
    }
    var isGmail = domain === 'gmail.com' || domain === 'googlemail.com';
    if (isGmail) {
      var gmailMessage = gmailError(local, domain);
      if (gmailMessage) return gmailMessage;
    }
    if (looksFakeLocal(local)) {
      return isGmail
        ? 'This Gmail address looks fake. Please use your real Gmail address.'
        : 'This email address looks fake. Please use your real email address.';
    }
    var fix = emailTypoFix(email);
    if (fix) return 'Did you mean ' + fix + '? Your sign-in code would not reach ' + domain + '.';
    return '';
  }

  function isJunkPhone(digits) {
    if (!digits || digits.length < 6) return false;
    if (/^(\d)\1+$/.test(digits)) return true;
    if (digits.charAt(0) === '0') return true;
    if ('01234567890123456789'.indexOf(digits) !== -1) return true;
    if ('98765432109876543210'.indexOf(digits) !== -1) return true;
    if ('09876543210987654321'.indexOf(digits) !== -1) return true;
    var up = true;
    var down = true;
    for (var i = 1; i < digits.length; i++) {
      var diff = Number(digits.charAt(i)) - Number(digits.charAt(i - 1));
      if (diff !== 1) up = false;
      if (diff !== -1) down = false;
    }
    return up || down;
  }

  function normalizePhone(raw, country) {
    var rule = phoneRule(country);
    var digits = String(raw || '').replace(/\D/g, '');
    if (!digits) return '';
    if (rule.code && digits.indexOf(rule.code) === 0) {
      var withoutCode = digits.slice(rule.code.length);
      if (withoutCode.length === rule.length) digits = withoutCode;
    }
    if (digits.charAt(0) === '0') {
      var withoutZero = digits.slice(1);
      if (withoutZero.length === rule.length) digits = withoutZero;
    }
    return digits;
  }

  function registerPhoneError(raw, country) {
    var name = country || 'India';
    var rule = phoneRule(name);
    var typed = String(raw || '').replace(/\D/g, '');
    if (!typed) return 'Enter your mobile number.';
    var digits = normalizePhone(raw, name);
    if (isJunkPhone(digits) || digits === '1234567890' || digits === '0987654321') {
      return 'Enter a real mobile number. 1234567890 and 0987654321 are not allowed.';
    }
    if (digits.length !== rule.length || !rule.test(digits)) return rule.message;
    return '';
  }

  function syncPhonePlaceholder() {
    var phone = registerField('phone');
    var country = registerField('country');
    if (!phone) return;
    phone.placeholder = phoneRule(country ? country.value : 'India').placeholder;
  }

  function validateRegisterStep(step, values) {
    var ok = true;
    if (step === 1) {
      var firstError = personNameError(values.firstName, 'first name');
      var lastError = personNameError(values.lastName, 'last name');
      setRegisterError('first_name', firstError);
      setRegisterError('last_name', lastError);
      if (firstError || lastError) ok = false;
    }
    if (step === 2) {
      var emailError = registerEmailError(values.email);
      var phoneError = registerPhoneError(values.phone, values.country || 'India');
      setRegisterError('email', emailError);
      setRegisterError('phone', phoneError);
      setRegisterError('terms', '');
      if (emailError || phoneError) ok = false;
    }
    if (step === 3) {
      if (!values.password) {
        setRegisterError('password', 'Create a password.');
        ok = false;
      } else if (values.password.length < 8) {
        setRegisterError('password', 'Use at least 8 characters.');
        ok = false;
      } else setRegisterError('password', '');
      if (!values.passwordConfirm) {
        setRegisterError('password_confirm', 'Re-enter your password.');
        ok = false;
      } else if (values.password !== values.passwordConfirm) {
        setRegisterError('password_confirm', 'Passwords do not match.');
        ok = false;
      } else setRegisterError('password_confirm', '');
      setRegisterError('terms', '');
    }
    return ok;
  }

  function passwordStepEnabled() {
    var field = registerField('password');
    return !!(field && field.type !== 'hidden');
  }

  function validateRegister(values) {
    var ok = true;
    if (registerField('first_name')) {
      var firstError = personNameError(values.firstName, 'first name');
      setRegisterError('first_name', firstError);
      if (firstError) ok = false;
    }
    if (registerField('last_name')) {
      var lastError = personNameError(values.lastName, 'last name');
      setRegisterError('last_name', lastError);
      if (lastError) ok = false;
    }
    var emailMessage = registerEmailError(values.email);
    setRegisterError('email', emailMessage);
    if (emailMessage) ok = false;
    if (registerField('phone')) {
      var phoneMessage = registerPhoneError(values.phone, values.country || 'India');
      setRegisterError('phone', phoneMessage);
      if (phoneMessage) ok = false;
    }
    if (registerField('terms')) {
      var termsMessage = values.terms ? '' : 'Please tick “I agree to Arssyllogi’s Terms and Privacy Policy” to create your account.';
      setRegisterError('terms', termsMessage);
      if (termsMessage) ok = false;
    }
    if (passwordStepEnabled()) ok = validateRegisterStep(3, values) && ok;
    return ok;
  }

  function registerReady(values) {
    if (registerField('first_name') && personNameError(values.firstName, 'first name')) return false;
    if (registerField('last_name') && personNameError(values.lastName, 'last name')) return false;
    if (registerEmailError(values.email)) return false;
    if (registerField('phone') && registerPhoneError(values.phone, values.country || 'India')) return false;
    if (registerField('terms') && !values.terms) return false;
    if (passwordStepEnabled()) {
      if (!values.password || values.password.length < 8) return false;
      if (values.password !== values.passwordConfirm) return false;
    }
    return true;
  }

  var registerBusy = false;

  function syncRegisterBtn() {
    if (!registerSubmit) return;
    var ready = registerReady(registerValues());
    registerSubmit.classList.toggle('is-ready', ready);
    registerSubmit.disabled = registerBusy;
  }

  if (registerForm) {
    var registerStep = 1;
    var registerPanels = Array.from(registerForm.querySelectorAll('[data-kk-register-panel]'));
    var registerStepLabels = Array.from(document.querySelectorAll('[data-kk-register-step-label]'));
    var registerNext = document.querySelector('[data-kk-register-next]');
    var registerBack = document.querySelector('[data-kk-register-back]');

    function lastRegisterStep() {
      if (passwordStepEnabled()) return 3;
      if (registerField('phone') || registerField('first_name')) return 2;
      return 1;
    }

    function showRegisterStep(step) {
      var last = lastRegisterStep();
      registerStep = step;
      registerPanels.forEach(function (panel) {
        panel.hidden = Number(panel.getAttribute('data-kk-register-panel')) !== step;
      });
      registerStepLabels.forEach(function (label) {
        var n = Number(label.getAttribute('data-kk-register-step-label'));
        label.classList.toggle('is-active', n === step);
        label.classList.toggle('is-done', n < step);
      });
      if (registerBack) registerBack.hidden = step === 1;
      if (registerNext) registerNext.hidden = step === last;
      if (registerSubmit) registerSubmit.hidden = step !== last;
      syncRegisterBtn();
    }

    syncRegisterPlace();
    syncPhonePlaceholder();
    var countryField = registerField('country');
    if (countryField) {
      countryField.addEventListener('change', function () {
        var stateSelect = registerField('state');
        var stateText = registerField('state_text');
        if (countryField.value === 'India' && stateText) stateText.value = '';
        if (countryField.value !== 'India' && stateSelect) stateSelect.value = '';
        syncRegisterPlace();
        syncPhonePlaceholder();
        var phone = registerField('phone');
        if (phone && phone.value.trim()) setRegisterError('phone', registerPhoneError(phone.value.trim(), countryField.value));
        syncRegisterBtn();
      });
    }

    var emailSuggestBtn = document.querySelector('[data-kk-register-email-suggest]');

    function syncEmailSuggestion() {
      if (!emailSuggestBtn) return;
      var field = registerField('email');
      var fix = field ? emailTypoFix(field.value.trim()) : '';
      emailSuggestBtn.hidden = !fix;
      emailSuggestBtn.textContent = fix ? 'Use ' + fix + ' instead' : '';
      emailSuggestBtn.setAttribute('data-email', fix || '');
    }

    if (emailSuggestBtn) {
      emailSuggestBtn.addEventListener('click', function () {
        var field = registerField('email');
        var fix = emailSuggestBtn.getAttribute('data-email');
        if (!field || !fix) return;
        field.value = fix;
        setRegisterError('email', registerEmailError(fix));
        syncEmailSuggestion();
        syncRegisterBtn();
        field.focus();
      });
    }

    registerForm.querySelectorAll('[data-kk-register-field]').forEach(function (field) {
      field.addEventListener('input', function () {
        if (registerClientError) {
          registerClientError.hidden = true;
          registerClientError.textContent = '';
        }
        syncEmailSuggestion();
        syncRegisterBtn();
      });
      field.addEventListener('change', function () {
        if (field.getAttribute('data-kk-register-field') === 'terms' && field.checked) setRegisterError('terms', '');
        syncRegisterBtn();
      });
    });

    var registerEmailField = registerField('email');
    var registerEmailOk = document.querySelector('[data-kk-register-ok="email"]');

    function syncEmailState(showErrors) {
      var typed = registerEmailField.value.trim();
      var message = typed ? registerEmailError(typed) : '';
      var looksComplete = /@[^@\s]+\.[a-z]{2,}$/i.test(typed);
      if (showErrors || registerEmailField.getAttribute('data-kk-touched') === '1' || looksComplete) {
        setRegisterError('email', message);
      } else if (!typed) {
        setRegisterError('email', '');
      }
      var valid = !!typed && !message;
      registerEmailField.classList.toggle('is-valid', valid);
      if (registerEmailOk) registerEmailOk.hidden = !valid;
    }

    if (registerEmailField) {
      registerEmailField.addEventListener('input', function () {
        syncEmailState(false);
        if (registerClientError && registerClientError.classList.contains('kk-auth__errors--exists')) {
          registerClientError.hidden = true;
          registerClientError.textContent = '';
          registerClientError.classList.remove('kk-auth__errors--exists');
        }
      });
      registerEmailField.addEventListener('blur', function () {
        if (registerEmailField.value.trim()) registerEmailField.setAttribute('data-kk-touched', '1');
        syncEmailState(true);
        syncEmailSuggestion();
      });
    }
    showRegisterStep(1);

    if (registerNext) {
      registerNext.addEventListener('click', function () {
        if (!validateRegisterStep(registerStep, registerValues())) return;
        showRegisterStep(Math.min(lastRegisterStep(), registerStep + 1));
      });
    }
    if (registerBack) {
      registerBack.addEventListener('click', function () {
        showRegisterStep(Math.max(1, registerStep - 1));
      });
    }

    function registerLoginUrl() {
      var root = document.querySelector('[data-kk-register]');
      return (root && root.getAttribute('data-kk-shopify-login'))
        || (root && root.getAttribute('data-kk-login-url'))
        || (window.routes && (window.routes.storefront_login_url || window.routes.account_login_url))
        || '/account/login';
    }

    function registerServerError(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var parts = [];
      doc.querySelectorAll('.errors li').forEach(function (item) {
        var text = item.textContent.replace(/\s+/g, ' ').trim();
        if (text) parts.push(text);
      });
      if (parts.length) return parts.join(' ');
      if (html.indexOf('data-kk-register-form') !== -1 && html.indexOf('kk-auth__confirm') === -1) {
        return 'Could not create your account. Check your details and try again.';
      }
      return '';
    }

    function isExistingAccountError(text) {
      return /already been taken|already exists|already registered|already have an account|we have sent an email/i.test(text || '');
    }

    function showExistingAccount(email) {
      var isGmail = /@(gmail|googlemail)\.com$/i.test(email || '');
      var kind = isGmail ? 'Gmail ID' : 'email ID';
      showRegisterStep(1);
      setRegisterError('email', 'An account already exists with this ' + kind + '.');
      if (!registerClientError) return;
      var url = registerLoginUrl();
      if (email && url.indexOf('login_hint=') === -1) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'login_hint=' + encodeURIComponent(email);
      }
      registerClientError.textContent = '';
      registerClientError.classList.add('kk-auth__errors--exists');
      var text = document.createElement('p');
      text.className = 'kk-auth__exists-text';
      text.appendChild(document.createTextNode('You already have an account created with this ' + kind + ' '));
      var strong = document.createElement('strong');
      strong.textContent = email;
      text.appendChild(strong);
      text.appendChild(document.createTextNode('. Please sign in instead.'));
      var link = document.createElement('a');
      link.className = 'kk-auth__exists-link';
      link.href = url;
      link.textContent = 'Sign in to my account';
      registerClientError.appendChild(text);
      registerClientError.appendChild(link);
      registerClientError.hidden = false;
      var field = registerField('email');
      if (field && field.focus) field.focus();
    }

    function goToLogin(email) {
      try {
        if (email) sessionStorage.setItem('kk-register-login', email);
      } catch (e) {}
      var logout = '/account/logout';
      var routed = window.routes && window.routes.account_logout_url;
      if (routed && (routed.charAt(0) === '/' || routed.indexOf(window.location.host) !== -1)) logout = routed;
      window.location.replace(logout);
    }

    var registerSuccessShown = false;
    function showRegisterSuccess(email) {
      if (registerSuccessShown) return;
      registerSuccessShown = true;
      var success = document.querySelector('[data-kk-register-success]');
      var link = success && success.querySelector('[data-kk-register-success-link]');
      var emailSlot = success && success.querySelector('[data-kk-register-success-email]');
      if (emailSlot) emailSlot.textContent = email || 'your email';
      if (link && email) {
        link.setAttribute('data-email', email);
        var href = link.getAttribute('href') || '';
        if (href.indexOf('login_hint=') === -1) {
          link.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'login_hint=' + encodeURIComponent(email));
        }
      }
      if (registerForm) registerForm.hidden = true;
      if (success) success.hidden = false;
      window.setTimeout(function () {
        goToLogin(email);
      }, 2400);
    }

    var registerSuccessLink = document.querySelector('[data-kk-register-success-link]');
    if (registerSuccessLink) {
      registerSuccessLink.addEventListener('click', function (event) {
        event.preventDefault();
        goToLogin(registerSuccessLink.getAttribute('data-email') || '');
      });
    }

    function stopRegisterSubmit(event) {
      if (!event || event.target !== registerForm) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    document.addEventListener('submit', stopRegisterSubmit, true);
    registerForm.addEventListener('submit', stopRegisterSubmit);

    function attemptRegister() {
      var values = registerValues();
      if (!validateRegister(values)) {
        if (registerClientError) {
          registerClientError.hidden = false;
          registerClientError.textContent = 'Please fix the highlighted fields to create your account.';
        }
        syncEmailSuggestion();
        showRegisterStep(lastRegisterStep());
        var firstInvalid = registerForm.querySelector('.is-invalid, [data-kk-register-field="terms"].is-invalid');
        if (!firstInvalid) firstInvalid = registerForm.querySelector('.kk-auth__field-error:not([hidden])');
        if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
        var errorText = registerForm.querySelector('.kk-auth__field-error:not([hidden])');
        if (errorText && errorText.scrollIntoView) errorText.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var generated = registerForm.querySelector('[data-kk-register-generated-password]');
      var generatedConfirm = registerForm.querySelector('[data-kk-register-generated-password-confirm]');
      if (generated && generatedConfirm && !passwordStepEnabled()) {
        var secret = 'Kk' + Math.random().toString(36).slice(2) + 'A1' + Date.now().toString(36);
        generated.value = secret;
        generatedConfirm.value = secret;
      }
      if (registerNote) registerNote.value = buildRegisterNote(values);
      persistPendingProfile(values);

      var submitLabel = registerSubmit ? registerSubmit.textContent : '';
      if (registerSubmit) {
        registerBusy = true;
        registerSubmit.disabled = true;
        registerSubmit.textContent = 'Creating account…';
      }
      if (registerClientError) {
        registerClientError.hidden = true;
        registerClientError.textContent = '';
        registerClientError.classList.remove('kk-auth__errors--exists');
      }

      fetch(registerForm.action, {
        method: 'POST',
        body: new FormData(registerForm),
        credentials: 'same-origin',
        redirect: 'manual',
      })
        .then(function (response) {
          var finalUrl = response.url || '';
          var homeRedirect = false;
          try {
            var parsed = new URL(finalUrl, window.location.origin);
            homeRedirect = parsed.pathname === '/' || parsed.pathname === '';
          } catch (e) {
            homeRedirect = finalUrl === '/';
          }
          var redirected =
            !homeRedirect &&
            (response.type === 'opaqueredirect' ||
              (response.status === 0 && !finalUrl) ||
              (response.status >= 300 && response.status < 400) ||
              /\/\d+\/account/.test(finalUrl));
          if (redirected) {
            showRegisterSuccess(values.email);
            return null;
          }
          return response.text().then(function (html) {
            if (/\/\d+\/account/.test(finalUrl) || (html.indexOf('Page not found') !== -1 && html.indexOf('data-kk-register-form') === -1)) {
              showRegisterSuccess(values.email);
              return null;
            }
            return html;
          });
        })
        .then(function (html) {
          if (html == null) return;
          if (html.indexOf('kk-auth__confirm') !== -1) {
            showRegisterSuccess(values.email);
            return;
          }
          var message = registerServerError(html);
          if (isExistingAccountError(message)) {
            showExistingAccount(values.email);
            if (registerSubmit) {
              registerBusy = false;
            registerSubmit.textContent = submitLabel;
              syncRegisterBtn();
            }
            return;
          }
          if (registerClientError) {
            registerClientError.hidden = false;
            registerClientError.textContent =
              message || 'Could not create your account. Please try again.';
          }
          showRegisterStep(lastRegisterStep());
          if (registerSubmit) {
            registerBusy = false;
            registerSubmit.textContent = submitLabel;
            syncRegisterBtn();
          }
        })
        .catch(function () {
          if (registerClientError) {
            registerClientError.hidden = false;
            registerClientError.textContent = 'Could not create your account. Please try again.';
          }
          if (registerSubmit) {
            registerBusy = false;
            registerSubmit.textContent = submitLabel;
            syncRegisterBtn();
          }
        });
    }

    if (registerSubmit) {
      registerSubmit.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (registerSubmit.disabled) return;
        attemptRegister();
      });
    }
  }

  function profileStorageKey(id, email) {
    if (id) return 'kk-profile:' + id;
    if (email) return 'kk-profile-email:' + String(email).toLowerCase();
    return '';
  }

  function readJSON(key) {
    if (!key) return null;
    try {
      return JSON.parse(localStorage.getItem(key) || 'null');
    } catch (e) {
      return null;
    }
  }

  function writeJSON(key, value) {
    if (!key) return;
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function toDateInput(value) {
    if (!value) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    var match = String(value).match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
    if (!match) return '';
    return match[3] + '-' + match[2].padStart(2, '0') + '-' + match[1].padStart(2, '0');
  }

  var profileForm = document.querySelector('[data-kk-profile-form]');
  if (profileForm) {
    var seedEl = profileForm.querySelector('[data-kk-profile-seed]');
    var seed = {};
    try {
      seed = seedEl ? JSON.parse(seedEl.textContent) : {};
    } catch (e) {
      seed = {};
    }

    var emailKey = String(seed.email || '').toLowerCase();
    var pending = readJSON('kk-profile-pending');
    if (!pending || String(pending.email || '').toLowerCase() !== emailKey) pending = null;
    var profiles = readJSON('kk-profiles') || {};
    var fromRegister = profiles[emailKey] || null;
    var stored = readJSON(profileStorageKey(seed.id, seed.email)) || {};

    function firstFilled() {
      for (var i = 0; i < arguments.length; i++) {
        if (arguments[i]) return arguments[i];
      }
      return '';
    }

    var merged = {
      id: seed.id,
      email: seed.email || '',
      firstName: firstFilled(seed.firstName, stored.firstName, fromRegister && fromRegister.firstName, pending && pending.firstName),
      lastName: firstFilled(seed.lastName, stored.lastName, fromRegister && fromRegister.lastName, pending && pending.lastName),
      phone: firstFilled(seed.phone, stored.phone, fromRegister && fromRegister.phone, pending && pending.phone),
      city: firstFilled(seed.city, stored.city, fromRegister && fromRegister.city, pending && pending.city),
      state: firstFilled(seed.state, stored.state, fromRegister && fromRegister.state, pending && pending.state),
      country: firstFilled(seed.country, stored.country, fromRegister && fromRegister.country, pending && pending.country) || 'India',
      dob: toDateInput(firstFilled(seed.dob, stored.dob, fromRegister && fromRegister.dob, pending && pending.dob)),
      gender: firstFilled(seed.gender, stored.gender, fromRegister && fromRegister.gender, pending && pending.gender),
    };

    if (pending || fromRegister) writeJSON(profileStorageKey(seed.id, seed.email), merged);
    if (pending) {
      try {
        localStorage.removeItem('kk-profile-pending');
      } catch (e) {}
    }

    function fillIfEmpty(name, value) {
      var input = profileForm.querySelector('[data-kk-profile-field="' + name + '"]');
      if (input && !String(input.value || '').trim() && value) input.value = value;
    }

    function helloLabel(name, email) {
      var value = String(name || '').trim();
      if (!value || value.indexOf('@') !== -1) {
        var source = value.indexOf('@') !== -1 ? value : String(email || '');
        value = source.split('@')[0].split('+')[0].split('.')[0].split('_')[0].split('-')[0].replace(/[0-9]/g, '');
      }
      value = String(value || '').trim();
      if (!value) value = 'there';
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }

    function paintHello(name) {
      var root = profileForm.closest('[data-kk-user-details]') || profileForm.closest('.kk-account');
      if (!root) return;
      var shown = helloLabel(name, seed.email);
      var hello = root.querySelector('[data-kk-hello]');
      var initial = root.querySelector('[data-kk-initial]');
      if (hello && shown) hello.textContent = 'Hello, ' + shown;
      if (initial && shown) initial.textContent = shown.charAt(0).toUpperCase();
    }

    fillIfEmpty('first_name', merged.firstName);
    fillIfEmpty('last_name', merged.lastName);
    fillIfEmpty('phone', merged.phone);
    fillIfEmpty('email', merged.email);
    paintHello(merged.firstName);

    var phoneField = profileForm.querySelector('[data-kk-profile-field="phone"]');
    var dobField = profileForm.querySelector('[data-kk-profile-field="dob"]');
    var cityField = profileForm.querySelector('[data-kk-profile-field="city"]');
    var stateSelect = profileForm.querySelector('[data-kk-profile-state-select]');
    var stateText = profileForm.querySelector('[data-kk-profile-field="state_text"]');
    var countryField = profileForm.querySelector('[data-kk-profile-field="country"]');
    if (cityField && !cityField.value && merged.city) cityField.value = merged.city;
    if (countryField && merged.country) countryField.value = merged.country;
    function profileStateValue() {
      if (!stateSelect && !stateText) return '';
      var india = !countryField || countryField.value === 'India';
      if (india) return stateSelect ? stateSelect.value.trim() : '';
      return stateText ? stateText.value.trim() : '';
    }
    function syncProfilePlace() {
      if (!countryField || !stateSelect || !stateText) return;
      var india = countryField.value === 'India';
      var known = false;
      if (stateSelect && merged.state) {
        Array.prototype.forEach.call(stateSelect.options, function (option) {
          if (option.value === merged.state) known = true;
        });
      }
      stateSelect.hidden = !india || (!known && !!merged.state && stateSelect.value !== merged.state);
      stateText.hidden = !stateSelect.hidden;
      if (!stateText.hidden && merged.state && !stateText.value) stateText.value = merged.state;
      if (stateSelect && known) stateSelect.value = merged.state;
    }
    syncProfilePlace();
    if (countryField) {
      countryField.addEventListener('change', function () {
        if (!stateSelect || !stateText) return;
        if (countryField.value === 'India') {
          stateSelect.hidden = false;
          stateText.hidden = true;
        } else {
          stateSelect.hidden = true;
          stateText.hidden = false;
        }
      });
    }
    if (dobField && !dobField.value && merged.dob) dobField.value = merged.dob;
    if (merged.gender) {
      var genderInput = profileForm.querySelector('[data-kk-profile-field="gender"][value="' + merged.gender + '"]');
      if (genderInput) genderInput.checked = true;
    }

    var firstNameInput = profileForm.querySelector('[data-kk-profile-field="first_name"]');
    if (firstNameInput) {
      firstNameInput.addEventListener('input', function () {
        paintHello(firstNameInput.value.trim());
      });
    }

    var editBtn = document.querySelector('[data-kk-profile-edit]');
    var cancelBtn = document.querySelector('[data-kk-profile-cancel]');
    var actions = document.querySelector('[data-kk-profile-actions]');
    var savedBanner = document.querySelector('[data-kk-profile-saved]');
    var profileError = document.querySelector('[data-kk-profile-error]');
    var fields = profileForm.querySelectorAll('[data-kk-profile-field]');

    function setEditing(isEditing) {
      if (!editBtn) return;
      fields.forEach(function (input) {
        input.disabled = !isEditing;
      });
      if (actions) actions.hidden = !isEditing;
      editBtn.hidden = isEditing;
    }

    function profileValues() {
      var gender = profileForm.querySelector('[data-kk-profile-field="gender"]:checked');
      return {
        id: seed.id,
        firstName: (profileForm.querySelector('[data-kk-profile-field="first_name"]') || {}).value || '',
        lastName: (profileForm.querySelector('[data-kk-profile-field="last_name"]') || {}).value || '',
        email: (profileForm.querySelector('[data-kk-profile-field="email"]') || {}).value || '',
        phone: (profileForm.querySelector('[data-kk-profile-field="phone"]') || {}).value || '',
        city: (profileForm.querySelector('[data-kk-profile-field="city"]') || {}).value || '',
        state: profileStateValue(),
        country: (profileForm.querySelector('[data-kk-profile-field="country"]') || {}).value || '',
        dob: (profileForm.querySelector('[data-kk-profile-field="dob"]') || {}).value || '',
        gender: gender ? gender.value : '',
      };
    }

    if (editBtn) {
      editBtn.addEventListener('click', function () {
        setEditing(true);
        var first = profileForm.querySelector('[data-kk-profile-field="first_name"]');
        if (first) first.focus();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
        profileForm.reset();
        fillIfEmpty('first_name', merged.firstName);
        fillIfEmpty('last_name', merged.lastName);
        fillIfEmpty('phone', merged.phone);
        if (dobField && merged.dob && !dobField.value) dobField.value = merged.dob;
        paintHello(merged.firstName);
        if (editBtn) setEditing(false);
      });
    }

    profileForm.addEventListener('submit', function (event) {
      var values = profileValues();
      var ok = true;
      var firstError = profileForm.querySelector('[data-kk-profile-error-for="first_name"]');
      var lastError = profileForm.querySelector('[data-kk-profile-error-for="last_name"]');
      var emailErrorEl = profileForm.querySelector('[data-kk-profile-error-for="email"]');
      var phoneErrorEl = profileForm.querySelector('[data-kk-profile-error-for="phone"]');

      function fieldMsg(inputName, errorEl, message) {
        var input = profileForm.querySelector('[data-kk-profile-field="' + inputName + '"]');
        if (errorEl) {
          errorEl.hidden = !message;
          errorEl.textContent = message || '';
        }
        if (input) input.classList.toggle('is-invalid', !!message);
      }

      var firstMsg = personNameError(values.firstName.trim(), 'first name');
      var lastMsg = personNameError(values.lastName.trim(), 'last name');
      var emailMsg = registerEmailError(values.email.trim());
      var phoneMsg = registerPhoneError(values.phone, 'India');
      fieldMsg('first_name', firstError, firstMsg);
      fieldMsg('last_name', lastError, lastMsg);
      fieldMsg('email', emailErrorEl, emailMsg);
      fieldMsg('phone', phoneErrorEl, phoneMsg);
      if (firstMsg || lastMsg || emailMsg || phoneMsg) ok = false;

      var cityInput = profileForm.querySelector('[data-kk-profile-field="city"]');
      if (cityInput) {
        var cityError = profileForm.querySelector('[data-kk-profile-error-for="city"]');
        var stateError = profileForm.querySelector('[data-kk-profile-error-for="state"]');
        var countryError = profileForm.querySelector('[data-kk-profile-error-for="country"]');
        if (!String(values.city).trim()) {
          fieldMsg('city', cityError, 'Enter your city.');
          ok = false;
        } else fieldMsg('city', cityError, '');
        if (!String(values.state).trim()) {
          fieldMsg('state', stateError, 'Select your state.');
          ok = false;
        } else fieldMsg('state', stateError, '');
        if (!String(values.country).trim()) {
          fieldMsg('country', countryError, 'Select your country.');
          ok = false;
        } else fieldMsg('country', countryError, '');
      }

      if (!ok) {
        event.preventDefault();
        if (profileError) {
          profileError.hidden = false;
          profileError.textContent = 'Please fix the highlighted fields.';
        }
        return;
      }

      var nextPassword = profileForm.querySelector('[data-kk-password-new]');
      var confirmPassword = profileForm.querySelector('[data-kk-password-confirm]');
      var passwordError = profileForm.querySelector('[data-kk-password-error]');
      var password = nextPassword ? nextPassword.value : '';
      var confirmValue = confirmPassword ? confirmPassword.value : '';
      if (password || confirmValue) {
        var passwordMessage = '';
        if (password.length < 8) passwordMessage = 'Use at least 8 characters.';
        else if (password !== confirmValue) passwordMessage = 'Passwords do not match.';
        if (passwordMessage) {
          event.preventDefault();
          if (passwordError) {
            passwordError.hidden = false;
            passwordError.textContent = passwordMessage;
          }
          if (confirmPassword) confirmPassword.classList.add('is-invalid');
          return;
        }
      } else {
        if (nextPassword) nextPassword.disabled = true;
        if (confirmPassword) confirmPassword.disabled = true;
      }

      var noteInput = profileForm.querySelector('[data-kk-profile-note]');
      var savedPhone = normalizePhone(values.phone, 'India') || String(values.phone || '').trim();
      if (noteInput) {
        var noteLines = [];
        if (values.firstName.trim()) noteLines.push('First name: ' + values.firstName.trim());
        if (values.lastName.trim()) noteLines.push('Last name: ' + values.lastName.trim());
        if (savedPhone) noteLines.push('Phone: ' + savedPhone);
        if (values.city) noteLines.push('City: ' + values.city.trim());
        if (values.state) noteLines.push('State: ' + values.state.trim());
        if (values.country) noteLines.push('Country: ' + values.country.trim());
        if (values.dob) noteLines.push('Date of birth: ' + values.dob);
        if (values.gender) noteLines.push('Gender: ' + values.gender);
        noteInput.value = noteLines.join('\n');
      }
      var savedProfile = {
        email: String(values.email || '').toLowerCase(),
        firstName: String(values.firstName || '').trim(),
        lastName: String(values.lastName || '').trim(),
        phone: savedPhone,
      };
      writeJSON(profileStorageKey(values.id, values.email), Object.assign({}, values, savedProfile));
      if (savedProfile.email) {
        var allProfiles = readJSON('kk-profiles') || {};
        allProfiles[savedProfile.email] = savedProfile;
        writeJSON('kk-profiles', allProfiles);
      }
      if (String(values.city || '').trim() || String(values.state || '').trim() || String(values.country || '').trim()) {
        try {
          localStorage.setItem(
            'kk-shipping',
            JSON.stringify({
              city: String(values.city || '').trim(),
              state: String(values.state || '').trim(),
              country: String(values.country || '').trim(),
            })
          );
        } catch (e) {}
      }
      if (savedBanner) savedBanner.hidden = false;
    });
  }
})();
